import {
  FlatBorderCard,
  Header,
  SecondaryButton,
  Space,
  Text,
} from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { AuthenticationRequiredPromptStyled } from './styles/AuthenticationRequiredPromptStyled'

type AuthenticationRequiredReason = 'initial' | 'historicalData'

export interface IAuthenticationRequiredPromptProps {
  onStartAuthentication: () => void
  reason?: AuthenticationRequiredReason
}

export const AuthenticationRequiredPrompt = ({
  onStartAuthentication,
  reason = 'initial',
}: IAuthenticationRequiredPromptProps) => {
  const intl = useProcurifyIntl()

  const copyByReason = {
    initial: {
      header: intl.formatMessage(messages.headerText),
      message: intl.formatMessage(messages.message),
      button: intl.formatMessage(messages.startAuthButtonText),
    },
    historicalData: {
      header: intl.formatMessage(messages.historicalDataHeaderText),
      message: intl.formatMessage(messages.historicalDataMessage),
      button: intl.formatMessage(messages.historicalDataButtonText),
    },
  }

  const copy = copyByReason[reason]

  return (
    <FlatBorderCard>
      <FlatBorderCard.Content>
        <Space align='center'>
          <AuthenticationRequiredPromptStyled>
            <Space align='center'>
              <Header as='h5' textAlign='center'>
                {copy.header}
              </Header>

              <Text align='center'>{copy.message}</Text>

              <SecondaryButton onClick={onStartAuthentication}>
                {copy.button}
              </SecondaryButton>
            </Space>
          </AuthenticationRequiredPromptStyled>
        </Space>
      </FlatBorderCard.Content>
    </FlatBorderCard>
  )
}
